export const importEmployeesEvents = {
  startEmployeesImporter: 'Start employees importer',
  closeEmployeesImporter: 'Close employees importer',
  uploadFileStep: {
    downloadTemplate: 'Download template employees importer',
    attachFile: 'Attach file employees importer',
    next: 'Upload file',
  },
  mapColumnsStep: {
    seeFields: 'See fields sidepanel',
    next: 'Fields mapped employees importer',
  },
  editionStep: {
    next: 'Tap create employees importer',
    confirm: 'Confirm create employees importer',
  },
}

export const unifiedAddEmployeeEvents = {
  addGeneralInformation: 'UnifiedEmployeeCreation: add general information',
  addPersonalInformation: 'UnifiedEmployeeCreation: add personal information',
  addWorkDetails: 'UnifiedEmployeeCreation: add work details information',
  addContractInformation: 'UnifiedEmployeeCreation: add contract information',
  addGeneralSettings: 'UnifiedEmployeeCreation: add general settings information',
  submitEmployeeModal: 'UnifiedEmployeeCreation: submitted',
  openAddEmployeeModal: 'UnifiedEmployeeCreation: open modal',
  closeAddEmployeeModal: 'UnifiedEmployeeCreation: close modal',
  backStep: 'UnifiedEmployeeCreation: click back step',
  submitError: 'UnifiedEmployeeCreation: submit error',
}

export const addEmployeeEvents = {
  createAddEmployeeFirstNameSubmit: 'Create add employee first name submit',
  createAddEmployeeEmailSubmit: 'Create add employee email submit',
  createAddEmployeeLastNameSubmit: 'Create add employee last name submit',
  chooseAddEmployeeLegalEntitySubmit: 'Choose add employee legal entity submit',
  addEmployeeNextSubmit: 'Add employee next submit',
  addEmployeeBackSubmit: 'Add employee back submit',
  addEmployeeCancelSubmit: 'Add employee cancel submit',
  chooseAddEmployeeRoleSubmit: 'Choose add employee role submit',
  chooseAddEmployeeLevelSubmit: 'Choose add employee level submit',
  chooseAddEmployeeSalaryTypeSubmit: 'Choose add employee salary type submit',
  chooseAddEmployeeGrossSalarySubmit: 'Choose add employee gross salary submit',
  chooseAddEmployeeContractStartDateSubmit: 'Choose add employee contract start date submit',

  chooseAddEmployeeSendFactorialInviteActivate:
    'Choose add employee send factorial invite activate',

  chooseAddEmployeeActivateWelcomeSpaceActivate:
    'Choose add employee activate welcome space activate',

  addEmployeeSuccess: 'Add employee success',
  createNewEmployeeJobRoleSubmit: 'Create new employee role job submit',
  createNewEmployeeJobLevelSubmit: 'Create new employee role level submit',
  employeeCreatedWithoutVisibility: 'Create new employee without visibility',
  addEmployeeFailure: 'Create new employee error',
}

export const employeeEvents = {
  page: {
    employeeList: {
      filterApplied: 'Filter employees',
      groupEmployees: 'Group employees',
      searchEmployee: 'Search employee',
      visited: ' Go to Employee',
    },
    orgChart: {
      visited: 'Go to Org Chart',
    },
    team: {
      visited: 'Go to Team',
    },
    jobCatalog: {
      visited: 'Go to Jobs',
    },
  },

  editEmployeeInformationSubmit: 'Edit employee information Submit',
  employeesResendInviteStart: 'Employees Resend Invite Start',
  employeesResendInviteFinish: 'Employees Resend Invite Finish',
  employeesSendInviteStart: 'Employees Send Invite Start',
  employeesSendInviteFinish: 'Employees Send Invite Finish',
  employeeSelectorFilters: 'Employee Selector Filters',

  profile: {
    editEmployeeProfileWorkInfoSubmit: 'Edit employee profile work information Submit',
    editEmployeeProfileTimeOffSubmit: 'Edit employee profile time off Submit',
  },

  personal: {
    addFirstName: 'Add first name in personal page',
    addLastName: 'Add last name in personal page',
    addPreferredPronouns: 'Add preferred pronouns in personal page',
    addBirthDate: 'Add date of birth in personal page',
    chooseLegalGender: 'Choose legal gender in personal page',
    chooseNationality: 'Choose nationality in personal page',
    addPhoneNumber: 'Add phone number in personal page',
    addCommunicationsEmail: 'Add communications email in personal page',
    editEmployeePersonalGeneralInformationSubmit:
      'Edit employee personal general information Submit',
    chooseIdentityDocument: 'Choose identity document in personal page',
    addIdNumber: 'Add ID number in personal page',
    addSocialSecurityNumber: 'Add social security number in personal page',
    editEmployeePersonalIdentificationSubmit: 'Edit employee personal identification Submit',
    editEmployeePersonalAddressSubmit: 'Edit employee personal address Submit',
    editEmployeePersonalFamilySubmit: 'Edit employee personal family situation Submit',
    editEmployeePersonalContactSubmit: 'Edit employee personal emergency contact Submit',
    editEmployeePersonalBankInfoSubmit: 'Edit employee personal bank info Submit',
    editEmployeePersonalPayrollInfoSubmit: 'Edit employee personal payroll info Submit',
    addAddressLineOne: 'Add address line 1 in personal page',
    addAddressLineTwo: 'Add address line 2 in personal page',
    addCity: 'Add city in personal page',
    addZipCode: 'Add zip code in personal page',
    addState: 'Add state/province/region in personal page',
    chooseCountry: 'Choose country in personal page',
    addIrpf: 'Add IRPF % in personal page',
    addEmergencyContact: 'Add emergency contact in personal page',
    addEmergencyPhoneNumber: 'Add emergency phone number in personal page',
    addBankNumber: 'Add bank number in personal page',
    addSwiftBic: 'Add SWIFT/BIC in personal page',
  },

  contracts: {
    addNewContractVersionSubmitOld: 'Add new contract version Submit Old',
    addCompensationFromContractsSubmit: 'Add compensation from contracts Submit',
    approveContractRequest: 'Approve contract request',
    changeToNewContractView: 'Try New Contract Layout',
    changeToOldContractView: 'Back to Old Contract Layout',
    editContractBasicInfoSubmit: 'Edit employee contract basic info Submit',
    editContractExtraInfoSubmit: 'Edit employee contract extra info Submit',
    editContractHoursSubmit: 'Edit employee contract hours Submit',
    editContractSalarySubmit: 'Edit employee contract salary Submit',
    deleteContractConditions: 'Delete contract conditions Submit',
    selectTimelineContractConditions: 'Select timeline contract conditions',
    fixContractConditionsStart: 'Fix contract conditions Start',
    seeTimelineContractConditions: 'See timeline contract conditions ',
    promoteContractNext: 'Promote Contract Next',
    promoteContractBack: 'Promote Contract Back',
    promoteContractSubmit: 'Promote contract Submit',
    promoteContractExit: 'Promote Contract Exit',
    rejectContractRequest: 'Reject contract request',
    requestPromoteContractNext: 'Request Promote Contract Next',
    requestPromoteContractBack: 'Request Promote Contract Back',
    requestPromoteContractSubmit: 'Request Promote contract Submit',
    requestPromoteContractExit: 'Request Promote Contract Exit',
    newContractConditionsStart: 'New contract conditions Start',
    updateContractNext: 'Update Contract Next',
    updateContractSubmit: 'Update Contract Submit',
    updateContractBack: 'Update Contract Back',
    updateContractExit: 'Update Contract Exit',
    fixContractStart: 'Fix Contract Start',
    fixContractNext: 'Fix Contract Next',
    fixContractSubmit: 'Fix Contract Submit',
    fixContractBack: 'Fix Contract Back',
    fixContractExit: 'Fix Contract Exit',
    goToFooterLink: 'Go to footer link Contract flow',
    goToSalaryLink: 'Go to salary link Contract flow',
    goToContractHoursLink: 'Go to contract hours link Contract flow',
    goToAC: 'Go to AC Contract flow',
    goToContractType: 'Go to Contract Type Contract flow',
    goToPayrollPolicies: 'Go to Payroll Policies Contract flow',
    goToCustomFields: 'Go to Custom Fields Contract flow',
    goToContractRequest: 'Go to Contract Request',
    startContractHistory: 'Start contract history',
    endActivityPeriodStart: 'F-D Inactivation Start',
    endActivityPeriodSubmit: 'F-D Inactivation Submit',
    startActivityPeriodStart: 'F-D Re-activation Start',
    startActivityPeriodSubmit: 'F-D Re-activation Submit',
  },

  termination: {
    terminateCancel: 'Terminate cancel',
    terminateStart: 'Terminate start',
    terminateSubmit: 'Terminate submit',
  },

  expandedAdd: {
    addNewEmployee: 'Add new employee',
    addProfileAndPersonalInformation: 'Add profile and personal information in employee creation',
    addContractInformation: 'Add contract information in employee creation',
  },

  legacyAdd: {
    addNewEmployee: 'Add new employee',
  },

  inBulk: {
    startImportOrExport: 'Import or Export employees start',
    importFileSubmit: 'Import new employee file submit',
    addImportEmployee: 'Add import employee',
  },
  become: {
    startBecome: 'Start a become of another user',
    closeBecomeHint: 'Close become hint',
  },
}

export const importContractsEvents = {
  startOldContractsImporter: 'Start old contracts importer',
  selectImportCurrentContract: 'Select import current contract',
  selectImportAllContractVersion: 'Select import all contract version',
  confirmUploadOldContractsImporter: 'Confirm upload old contracts importer',
}

export const editEmployeesInBulkEvents = {
  startBulkEdit: 'Start Bulk Edit',
  employeesBulkEdit: 'Employees Bulk Edit',
  confirmBulkEdit: 'Confirm Bulk Edit',
  resetBulkEdit: 'Reset Bulk Edit',
  saveBulkEdit: 'Save Bulk Edit',
}

export const oldImportEmployeesEvents = {
  startOldEmployeesImporter: 'Start old employees importer',
  uploadedFileOldEmployeesImporter: 'Uploaded file old employees importer',
  confirmUploadOldEmployeesImporter: 'Confirm upload old employees importer',
}

export const fixAgreementInBulkEvents = {
  startFixAgreement: 'Start Fix Agreement',
  fixAgreementNewCompensation: 'Fix Agreement New Compensation',
  fixAgreementSelectPolicy: 'Fix Agreement Select Policy',
  fixAgreementEditCompensation: 'Fix Agreement Edit Compensation',
  fixAgreementSave: 'Fix Agreement Save',
}

export const bulkTerminationEvents = {
  start: 'Bulk Termination Start',
  submit: 'Bulk Termination Submit',
}

export const bulkPauseEvents = {
  start: 'Bulk Fijos Pause Start',
  submit: 'Bulk Fijos Pause Submit',
}

export const bulkActivateEvents = {
  start: 'Bulk Fijos Activate Start',
  submit: 'Bulk Fijos Activate Submit',
}

export const employeesDataCollection = {
  employeesListFiltered: 'Employees List Filtered',
  employeesListSearched: 'Employees List Searched',
  addEmployeeEvent: 'Add person',
  employeeListSelect: 'Employees List Select',
  importPeople: 'Import people',
  importContracts: 'Import contracts',
  exportData: 'Export data',
  editContracts: 'Edit contracts',
  addTimeOff: 'Add time off',
  importTimeOffAllowances: 'Import time off allowances',
  importDataTables: 'Import data tables',
  importFromDatev: 'Import from DATEV',
}
